import { isLyrraOne } from '@/lib/platform';
import {
  canAccessAdminPanel,
  canAccessLearnerWorkspace,
  canAccessTrainerDashboard,
} from '@/lib/auth-role';
import { formateurDashboardTabPath } from '@/lib/institution-tab-registry';

export const MOBILE_VIEWPORT_QUERY = '(max-width: 767px)';

/** Seule section formateur accessible sur smartphone LyrraOne. */
export const MOBILE_TRAINER_SALES_PATH = formateurDashboardTabPath('billing');

export function isMobileViewport(): boolean {
  if (typeof window === 'undefined') return false;
  return window.matchMedia(MOBILE_VIEWPORT_QUERY).matches;
}

export function isMobileTrainerSalesRoute(pathname: string, search = ''): boolean {
  if (pathname !== '/dashboard') return false;
  const tab = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search).get('tab');
  return tab === 'billing';
}

/** Route formateur autorisée sur smartphone (LyrraOne). */
export function isMobileTrainerAllowedRoute(pathname: string, search = ''): boolean {
  if (!isLyrraOne() || !isMobileViewport()) return true;
  return isMobileTrainerSalesRoute(pathname, search);
}

export function shouldBlockTrainerRouteOnMobile(
  pathname: string,
  search: string,
  role: string | null | undefined,
): boolean {
  if (!isLyrraOne() || !isMobileViewport()) return false;
  if (!canAccessTrainerDashboard(role)) return false;
  return !isMobileTrainerAllowedRoute(pathname, search);
}

/** @deprecated Utiliser shouldBlockTrainerRouteOnMobile */
export function shouldBlockTrainerWorkspaceOnMobile(role: string | null | undefined): boolean {
  if (!isLyrraOne() || !isMobileViewport()) return false;
  return canAccessTrainerDashboard(role);
}

/** Administration plateforme — ordinateur uniquement sur mobile. */
export function shouldBlockAdminPanelOnMobile(role: string | null | undefined): boolean {
  if (!isMobileViewport()) return false;
  return canAccessAdminPanel(role);
}

export function getMobileTrainerSalesPath(): string {
  return MOBILE_TRAINER_SALES_PATH;
}

export function getMobileFallbackPath(role: string | null | undefined): string {
  if (canAccessTrainerDashboard(role) && isLyrraOne()) return MOBILE_TRAINER_SALES_PATH;
  if (canAccessLearnerWorkspace(role)) return '/learner';
  return '/login';
}

export function getLyrraOneMobilePostAuthPath(
  role: string,
  user?: { storePurchaseCount?: number | null },
): string {
  if (canAccessTrainerDashboard(role)) return MOBILE_TRAINER_SALES_PATH;
  if (canAccessLearnerWorkspace(role)) return '/learner';
  if (['student', 'learner'].includes(role)) return '/learner';
  if ((user?.storePurchaseCount ?? 0) > 0) return '/learner';
  return '/learner';
}
